export default __webpack_public_path__ + "static/media/DGX-H100-2.01947dd6.png";